import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import NewSellyoMembers from "../../../components/apps/sellyo-members/NewSellyoMembers";
import { useNavigate } from "react-router";

export default function NewSellyoMembersPage() {
    const navigate = useNavigate();
    return (
        <>
            <PageMeta title="Sellyo Members — Nova Integração" description="Nova integração Sellyo Members" />
            <PageBreadcrumb
                pageTitle="Nova Integração"
                showBackButton={true}
                onBack={() => navigate("/apps/sellyo-members")}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 space-y-6">
                    <NewSellyoMembers />
                </div>
            </div>
        </>
    );
}